import gql from 'graphql-tag'

export const CREATE_TEMP_HOLD = gql`
  mutation createTempHold($createTempHoldInput: PutTempHoldInput!) {
    createTempHold(createTempHoldInput: $createTempHoldInput) {
      ServiceResult {
        SessionInfo {
          Id
          StudentId
          InstructorId
          ProgramId
          StartTime
          EndTime
        }
      }
    }
  }
`

export const DELETE_RECORD = gql`
  mutation deleteRecord($ids: String!) {
    deleteRecord(ids: $ids) {
      ServiceResult {
        id
        success
      }
    }
  }
`

export const DELETE_ALL_TEMP_SESSION = gql`
  mutation DeleteAllTempSession($ProgramId: String!) {
    deleteAllTempSession(ProgramId: $ProgramId) {
      ServiceStatus {
        Success
        StatusCode
        Timestamp
      }
    }
  }
`
